'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _theme = require('../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line

var DefaultIndicator = function DefaultIndicator(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      indicatorContent = _ref.indicatorContent;
  var loading = theme.components.loading;

  return _react2.default.createElement(
    Container,
    { size: size },
    _react2.default.createElement(
      Svg,
      { size: size },
      _react2.default.createElement(Path, {
        cx: loading.sizes[size].width / 2 // circle X coord
        , cy: loading.sizes[size].width / 2 // circle Y coord
        , r: loading.sizes[size].width / 3 // the radius is 1/3 of the width
        , strokeWidth: loading.sizes[size].stroke,
        strokeMiterlimit: '10'
      })
    ),
    _react2.default.createElement(
      IconHolder,
      null,
      indicatorContent
    )
  );
};

function rotate() {
  return (/*#__PURE__*/(0, _theme.keyframes)('100%{transform:rotate(360deg);}')
  );
}

function dash() {
  return (/*#__PURE__*/(0, _theme.keyframes)('0%{stroke-dasharray:1,200;stroke-dashoffset:0;}50%{stroke-dasharray:89,200;stroke-dashoffset:-35;}100%{stroke-dasharray:89,200;stroke-dashoffset:-185;}')
  );
}

function color(theme) {
  var colors = theme.components.loading.colors;

  return (/*#__PURE__*/(0, _theme.keyframes)('100%,0%{stroke:', colors.color1, ';}40%{stroke:', colors.color2, ';}66%{stroke:', colors.color3, ';}80%,90%{stroke:', colors.color4, ';}')
  );
}

var Svg = /*#__PURE__*/(0, _theme.styled)('svg', {
  target: 'e1smg49r0'
})('position:relative;width:', function (_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size;
  return theme.components.loading.sizes[size].width;
}, 'px;height:', function (_ref3) {
  var theme = _ref3.theme,
      size = _ref3.size;
  return theme.components.loading.sizes[size].width;
}, 'px;fill:none;animation:', function () {
  return rotate();
}, ' 2s linear infinite;');

var Path = /*#__PURE__*/(0, _theme.styled)('circle', {
  target: 'e1smg49r1'
})('stroke-dasharray:1,200;stroke-dashoffset:0;stroke-linecap:round;animation:', function () {
  return dash();
}, ' 1.5s ease-in-out infinite,', function (_ref4) {
  var theme = _ref4.theme;
  return color(theme);
}, ' 6s ease-in-out infinite;');

var IconHolder = /*#__PURE__*/(0, _theme.styled)('div', {
  target: 'e1smg49r2'
})('position:absolute;top:0;left:0;height:100%;width:100%;justify-content:center;align-items:center;display:flex;');

var Container = /*#__PURE__*/(0, _theme.styled)('span', {
  target: 'e1smg49r3'
})('display:inline-block;position:relative;z-index:1;width:', function (_ref5) {
  var theme = _ref5.theme,
      size = _ref5.size;
  return theme.components.loading.sizes[size].width;
}, 'px;height:', function (_ref6) {
  var theme = _ref6.theme,
      size = _ref6.size;
  return theme.components.loading.sizes[size].width;
}, 'px;');

exports.default = DefaultIndicator;